import React, { useEffect } from 'react'
import { HashRouter, Routes, Route } from 'react-router-dom'
import Home from './pages/Home'
import DashboardHome from './pages/dashboard/Home'
import './App.css'
import LoginPage from './pages/Login'
import Salary from './pages/dashboard/Salary'
import ProfileForm from './pages/dashboard/Profile'
import LoadConfig from './LoadConfig'
import HouseProperty from './pages/dashboard/HousePropertyPage'
import DeductionPage from './pages/dashboard/Deduction'
import PrivateRoute from './PrivateRoute'
import Logout from './pages/Logout'
import OtherSources from './pages/dashboard/OtherSources'
import CapitalGain from './pages/dashboard/CapitalGain'
import FillingSection from './pages/dashboard/FillingSection'
import DeductionChapterSix from './pages/dashboard/DeductionChapterSix'
import ExemptIncome from './pages/dashboard/ExemptIncome'
import Tds from './pages/dashboard/Tds'
import NotFound from './pages/NotFound'
import ProfilePage from './pages/dashboard/ProfilePage'
import LoginV2 from './pages/LoginV2'
import OtpVerification from './pages/OtpVerification'
import DualOtpVerify from './pages/DualOtpVerify'
import PrefillDataModal from './pages/PreFilledDataModal'
import FinalOtp from './pages/FinalOtp'
import IncomeTaxCalculator from './pages/IncomeTaxCalculator'
import Service from './pages/Service'
import About from './pages/About'
import Contact from './pages/Contact'
import ReturnTypeSelection from './pages/ReturnTypeSelection'
import Tds24QForm from './pages/dashboard/Tds24QForm'
import Tds24QCorrectionForm from './pages/dashboard/Tds24QCorrectionForm'
import Tds24Q4Form from './pages/dashboard/Tds24Q4Form'
import Tds24Q4CorrectionForm from './pages/dashboard/Tds24Q4CorrectionForm'
import Tds26QForm from './pages/dashboard/Tds26QForm'
import Tds26QCorrectionForm from './pages/dashboard/Tds26QCorrectionForm'
import Tds27QForm from './pages/dashboard/Tds27QForm'
import Tds27QCorrectionForm from './pages/dashboard/Tds27QCorrectionForm'
import Tds27EQForm from './pages/dashboard/Tds27EQForm'
import Tds27EQCorrectionForm from './pages/dashboard/Tds27EQCorrectionForm'
import Tds138Form from './pages/dashboard/Tds138Form'
import Tds138CorrectionForm from './pages/dashboard/Tds138CorrectionForm'
import Tds140Form from './pages/dashboard/Tds140Form'
import Tds140CorrectionForm from './pages/dashboard/Tds140CorrectionForm'
import Tds143Form from './pages/dashboard/Tds143Form'
import Tds143CorrectionForm from './pages/dashboard/Tds143CorrectionForm'
import Tds144Form from './pages/dashboard/Tds144Form'
import Tds144CorrectionForm from './pages/dashboard/Tds144CorrectionForm'
import TdsReturnStart from './pages/dashboard/TdsReturnStart'
import PremiumAuth from './pages/PremiumAuth'
import ClientDashboard from './pages/dashboard/ClientDashboard'
import Gstr7Form from './pages/dashboard/Gstr7Form'
import Gstr1Form from './pages/dashboard/Gstr1Form'
import Gstr3BForm from './pages/dashboard/Gstr3BForm'
import UploadReturnForm from './pages/dashboard/UploadReturnForm'
import { PageSaveProvider } from './contexts/PageSaveContext'
import { ServerPageStatusProvider } from './contexts/ServerPageStatusContext'
import { ErrorProvider } from './contexts/ErrorContext'
import ErrorSidebar from './components/common/ErrorSidebar'
import AiUploadModal from './components/common/AiUploadModal'
import WelcomeAnimation from './pages/WelcomeAnimation'
import CaseLawsHub from './pages/caselaws/CaseLawsHub'
import CaseLawDetail from './pages/caselaws/CaseLawDetail'


const App = () => {
  useEffect(() => {
    // Clear data when application is closed (window/tab closed or refreshed)
    const handleUnload = () => {
      localStorage.clear();
      sessionStorage.clear();
    };

    window.addEventListener('beforeunload', handleUnload);
    return () => {
      window.removeEventListener('beforeunload', handleUnload);
    };
  }, []);

  return (
    <div>
      <HashRouter>
        <PageSaveProvider>
          <ServerPageStatusProvider>
            <ErrorProvider>
              <LoadConfig />
              <ErrorSidebar />
              <AiUploadModal />
              <Routes>
                <Route path='/' element={<WelcomeAnimation />} />
                <Route path='/home' element={<Home />} />
                <Route path='/login-v2' element={<LoginV2 />} />
                <Route path='/about' element={<About />} />
                <Route path='/otp-verification' element={<OtpVerification />} />
                <Route path='/dual-otp-verification' element={<DualOtpVerify />} />
                <Route path='/final-otp' element={<FinalOtp />} />
                <Route path='/pre-filled-data' element={<PrefillDataModal />} />
                <Route path='/calculator' element={<IncomeTaxCalculator />} />
                <Route path='/services' element={<Service />} />
                <Route path='/case-laws' element={<CaseLawsHub />} />
                <Route path='/case-laws/income-tax' element={<CaseLawsHub defaultCategory="INCOME_TAX" />} />
                <Route path='/case-laws/gst' element={<CaseLawsHub defaultCategory="GST" />} />
                <Route path='/case-laws/:slug' element={<CaseLawDetail />} />
                <Route path='/login' element={<LoginPage />} />
                <Route path='/premium-auth' element={<PremiumAuth />} />
                <Route path='/clients' element={<ClientDashboard />} />
                <Route path='/logout' element={<Logout />} />
                <Route path='/contact' element={<Contact />} />
                <Route path='/return-selection' element={<ReturnTypeSelection />} />
                <Route path='/tds-dashboard/start' element={<TdsReturnStart />} />
                <Route path='/tds-dashboard/24q' element={<Tds24QForm />} />
                <Route path='/tds-dashboard/24q-correction' element={<Tds24QCorrectionForm />} />
                <Route path='/tds-dashboard/24q4' element={<Tds24Q4Form />} />
                <Route path='/tds-dashboard/24q4-correction' element={<Tds24Q4CorrectionForm />} />
                <Route path='/tds-dashboard/26q' element={<Tds26QForm />} />
                <Route path='/tds-dashboard/26q-correction' element={<Tds26QCorrectionForm />} />
                <Route path='/tds-dashboard/27q' element={<Tds27QForm />} />
                <Route path='/tds-dashboard/27q-correction' element={<Tds27QCorrectionForm />} />
                <Route path='/tds-dashboard/27eq' element={<Tds27EQForm />} />
                <Route path='/tds-dashboard/27eq-correction' element={<Tds27EQCorrectionForm />} />
                <Route path='/tds-dashboard/138' element={<Tds138Form />} />
                <Route path='/tds-dashboard/138-correction' element={<Tds138CorrectionForm />} />
                <Route path='/tds-dashboard/140' element={<Tds140Form />} />
                <Route path='/tds-dashboard/140-correction' element={<Tds140CorrectionForm />} />
                <Route path='/tds-dashboard/143' element={<Tds143Form />} />
                <Route path='/tds-dashboard/143-correction' element={<Tds143CorrectionForm />} />
                <Route path='/tds-dashboard/144' element={<Tds144Form />} />
                <Route path='/tds-dashboard/144-correction' element={<Tds144CorrectionForm />} />
                <Route path='/gst-dashboard/gstr7' element={<Gstr7Form />} />
                <Route path='/gst-dashboard/gstr1' element={<Gstr1Form />} />
                <Route path='/gst-dashboard/gstr3b' element={<Gstr3BForm />} />
                <Route path='/gst-dashboard/upload-return' element={<UploadReturnForm />} />

                <Route element={<PrivateRoute />}>
                  <Route path='/dashboard' element={<DashboardHome />} />
                  <Route path='/dashboard/salary' element={<Salary />} />
                  <Route path='/dashboard/profile' element={<ProfilePage />} />
                  <Route path='/dashboard/house-property' element={<HouseProperty />} />
                  <Route path='/dashboard/other-sources' element={<OtherSources />} />
                  <Route path='/dashboard/capital-gain' element={<CapitalGain />} />
                  <Route path='/dashboard/filing-section' element={<FillingSection />} />
                  <Route path='/dashboard/deduction-vi-a' element={<DeductionPage />} />
                  <Route path='/dashboard/exempt-income' element={<ExemptIncome />} />
                  <Route path='/dashboard/tds-tcs' element={<Tds />} />
                  <Route path="*" element={<NotFound />} />
                </Route>
              </Routes>
            </ErrorProvider>
          </ServerPageStatusProvider>
        </PageSaveProvider>
      </HashRouter>
    </div>
  )
}

export default App
